module.exports = "/_Resources/Static/Packages/CodeQ.Site/Frontend/build/images/pin-red.svg";